<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm danh sách cộng tác viên</h1>
      <div class="btn-group float-right">
        <button @click="$router.go(-1)" class="f12 font-medium btn btn-outline-secondary">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="step-content">
          <label>Chọn loại agency <span style="color: red">*</span></label>

          <div class="d-flex justìy-content-between align-item-center">
            <Select2
              placeholder="Chọn file mẫu theo loại agency"
              style="width: 80%; padding-right: 10px"
              :options="sampleFile"
              v-model="modelFile"
              @select="mySelectEvent($event)"
            >
            </Select2>
            <button
              style="button ; width: 119px"
              class="pull-right btn btn-outline-primary"
              @click="exportModel"
            >
              Tải mẫu
            </button>
          </div>

          <p style="color: red; margin: 5px 0px 0px 0px">
            {{ messSelectFormat }}
          </p>

          <div class="step-upfile">
            <section class="open-input">
              <div class="input-file-container" style="width: 230px">
                <label tabindex="0" for="my-file" class="btn btn-outline-secondary"
                  >Chọn file tải lên</label
                >
                <input
                  class="input-file"
                  style="display: none"
                  id="my-file"
                  type="file"
                  ref="file"
                  @change="uploadFileExcel"
                />
                <p v-if="this.messFailFormat != ''" style="color: red">
                  {{ this.messFailFormat }}
                </p>
              </div>
              <p class="file-return"></p>
            </section>

            <p class="text-primary">{{ fileName }}</p>
            <p>Hỗ trợ các tệp có định dạng *.xls, *.xlsx</p>
          </div>

          <div class="step-upfooter">
            <button type="button" class="btn btn-outline-secondary" @click="$router.go(-1)">
              Hủy bỏ
            </button>

            <button
              type="button"
              id="download-file-invalid"
              @click="downLoadDetailExcel()"
              class="btn btn-outline-primary ml-1"
              v-show="showDownLoadFile"
            >
              <i class="bx bx-archive-in"></i> Tải file
            </button>

            <button
              type="button"
              class="btn btn-outline-primary ml-1"
              @click="inportFileExcel()"
              v-show="!showDownLoadFile"
            >
              Xác nhận
            </button>
          </div>

          <div class="history-file m-t-20">
            <h3 class="m-b-10">Lịch sử upfile</h3>
            <div style="max-height: 500px; overflow-y: scroll; overflow-x: hidden">
              <b-table :fields="fields" :items="dataHistoryUpload" sticky-header="stickyHeader" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-scoped" v-model="showModalSuccess">
      <template #modal-header="{}">
        <h5>Thông báo</h5>
      </template>

      <div class="text-center">
        <img src="@/assets/img/noti-success2.svg" alt="icon-successs" />
        <h2 class="f18 py-3">Thêm mới thành công</h2>
      </div>

      <template #modal-footer="{}">
        <b-button size="sm" variant="light" @click="$router.go(-1)"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { AgentService } from '@/services/agent.service'

  export default {
    data() {
      return {
        dataTableExcel: [],
        dataHistoryUpload: [],
        modelFile: '',
        messSelectFormat: '',
        messFailFormat: '',
        selectForm: '',
        fileName: null,
        formData: new FormData(),
        showModalSuccess: false,
        showDownLoadFile: false,
        stickyHeader: true,
        sampleFile: [],
        invalidImportAgentFile: {
          fileInvalidName: '',
          param: '',
        },
        reqApiDownloadTemplate: {
          agentGroup: '',
        },
        fields: [
          { key: 'timeUpload', label: 'Thời gian' },
          { key: 'fileName', label: 'Tên file' },
          { key: 'userUpload', label: 'Người upload' },
        ],
      }
    },

    created() {
      this.getListAgentGroup()
      this.getListHistory()
    },

    methods: {
      // get list agent
      async getListAgentGroup() {
        try {
          const listAgent = await AgentService.getListAgentGroup()

          for (let i = 0; i < listAgent.data.length; i++) {
            const data = {
              id: i,
              text: listAgent.data[i].code,
            }
            this.sampleFile.push(data)
          }
        } catch (error) {
          console.log(error)
        }
      },

      // select model file
      mySelectEvent({ text }) {
        this.reqApiDownloadTemplate.agentGroup = text
        this.formData.delete('agentGroup')
        this.formData.append('agentGroup', this.reqApiDownloadTemplate.agentGroup)
      },

      // Button Tải mẫu
      async exportModel() {
        try {
          await AgentService.downloadTemplateImportAgent(this.reqApiDownloadTemplate)
          this.messSelectFormat = ''
        } catch (error) {
          this.messSelectFormat = 'Loại Agency không được bỏ trống !'
        }
      },

      // import file upload
      async uploadFileExcel(file) {
        try {
          const allowedExtensions = /(\.xls|\.xlsx)$/i
          const checkFomat = allowedExtensions.exec(file.target.files[0].name)

          this.showDownLoadFile = false
          this.messFailFormat = ''
          this.fileName = file.target.files[0].name
          this.formData.delete('file')
          this.formData.delete('urlFile')
          this.formData.append('file', file.target.files[0])
          this.formData.append('urlFile', file.target.files[0].name)

          if (!checkFomat) {
            this.messFailFormat = 'Định dạng không hợp lệ !'
            this.fileName = null
          }
        } catch (error) {
          console.log(error)
        }
      },

      // Button Xác nhận (upload file)
      async inportFileExcel() {
        try {
          console.log(this.formData)
          const data = await AgentService.importAgentExcel(this.formData)

          if (data.success) {
            this.showModalSuccess = true
          }

          if (this.fileName === null) {
            this.messFailFormat = 'Vui lòng chọn file tải lên !'
          }

          switch (data.code) {
            case 1008:
              this.messFailFormat = data.message
              break
            case 1009:
              this.showDownLoadFile = true
              this.invalidImportAgentFile.param = data.data
              this.invalidImportAgentFile.fileInvalidName = this.fileName
              this.messFailFormat =
                'Thông tin trong file không đúng quy định. Tải file để xem chi tiết lỗi'
              break
            default:
              break
          }

          switch (this.modelFile) {
            case '':
              this.messSelectFormat = 'Loại Agency không được bỏ trống !'
              break
            default:
              this.messSelectFormat = ''
              break
          }
        } catch (error) {
          console.log(error)
        }
      },

      // Button "Tải file"
      async downLoadDetailExcel() {
        try {
          this.fileName = null
          this.showDownLoadFile = false
          this.messFailFormat = ''
          this.$refs.file.value = ''

          await AgentService.downloadInvalidImportExcel(this.invalidImportAgentFile)
        } catch (error) {
          console.log(error)
        }
      },

      // History upload
      async getListHistory() {
        try {
          const dataResponse = await AgentService.historyUpload()
          if (dataResponse.code === 1000) {
            this.dataHistoryUpload = dataResponse.data
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
